<template>
    <rkm-layout-body title="Lista de usuário">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-usuario-create' })"
                color="primary"
                authorize="store-cadastro-usuario"
            >
                Cadastrar usuário
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/usuario/List'

export default {
    components: { List },
}
</script>